import { render, staticRenderFns } from "./ProfileReadMoreModal.vue?vue&type=template&id=79eabfd4"
import script from "./ProfileReadMoreModal.vue?vue&type=script&lang=js"
export * from "./ProfileReadMoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports